/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import dayjs from '@/lib/dayjs';

export type TimeUnits = 'days' | 'months' | 'years';

export type TimeAgoType = {
  time: number;
  unit: TimeUnits;
};

export type TimeAgoParams = {
  value: number | string | Date;
  toCompareWith?: number | string | Date;
};

export const getTimeAgo = (dates: TimeAgoParams): TimeAgoType => {
  const date = dayjs(dates.value);
  const today = dates.toCompareWith ? dayjs(dates.toCompareWith) : dayjs();

  if (date.isAfter(today)) {
    return { time: 0, unit: 'days' };
  }

  const daysAgo = today.diff(date, 'day');

  if (daysAgo < 31) {
    return { time: daysAgo, unit: 'days' };
  }

  const monthsAgo = today.diff(date, 'month');

  if (monthsAgo < 12) {
    return { time: monthsAgo, unit: 'months' };
  }

  const yearsAgo = today.diff(date, 'year');
  return { time: yearsAgo, unit: 'years' };
};
